import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { RefreshCw } from "lucide-react";

// One-tap escape from a spiral — present on every screen except immersive ones.
const HIDE = ["/", "/login", "/register", "/onboarding", "/immersions/", "/resets/", "/talk", "/coach"];

export default function FloatingResetButton() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
  if (!user) return null;
  if (HIDE.some((r) => (r.endsWith("/") ? pathname.startsWith(r) : pathname === r))) return null;

  return (
    <>
      <motion.button initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.8, type: "spring", stiffness: 200 }}
        onHoverStart={() => setHover(true)} onHoverEnd={() => setHover(false)} onClick={() => navigate("/resets")}
        className="fixed bottom-24 md:bottom-6 right-4 z-40 w-12 h-12 rounded-full bg-primary text-primary-foreground shadow-xl shadow-primary/30 flex items-center justify-center hover:scale-105 transition-transform"
        data-testid="floating-reset-btn" aria-label="Quick reset">
        <motion.div animate={{ rotate: hover ? 180 : 0 }} transition={{ duration: 0.3 }}><RefreshCw size={18} strokeWidth={2.5} /></motion.div>
      </motion.button>
      <AnimatePresence>
        {hover && (
          <motion.div initial={{ opacity: 0, x: 8 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 8 }}
            className="fixed bottom-[104px] md:bottom-[26px] right-[68px] z-40 glass text-foreground text-xs px-3 py-2 rounded-lg whitespace-nowrap">Quick reset</motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
